import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import SignatureIcon from "assets/icons/signature.svg?react";
import { useContext, useState } from "react";
import CreateHistory from "components/CreateHistory";
import editorService from "api/editorService";
import { IPackage } from "dto/IPackage";
import moment from "moment";
import { useNavigate } from "react-router";
import CertContext from "contexts/CertContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";

import DownloadIcon from "assets/icons/download.svg?react";
import CopyIcon from "assets/icons/copyd.svg?react";
import { useTranslation } from "react-i18next";

const Box = ({
  pack,
  history,
  idx,
}: {
  pack: IPackage;
  history: any;
  idx: number;
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  useContext(CertContext);

  const handleDownload = () => {};
  const handlePreview = () => {};
  const handleDuplicate = () => {};

  return (
    <div
      onClick={() => {
        const isFullscreen = window.location.href.search("fullscreen") !== -1;

        let newUrl = `${window.location.pathname}?pdf=${
          pack.Id
        }:${"dokument.pdf"}:${history.SignedUri ?? history.Uri}:${pack.Kind}:${
          pack.EncryptionKeyId
        }`;
        if (isFullscreen) {
          newUrl += "&fullscreen=1";
        }

        navigate(newUrl);

        // navigate(
        //   `/packages/${filterId ?? "1B8AE8D3-3209-497D-9526-27608FFFA84D"}/${
        //     status ?? "incoming"
        //   }/${pack.Kind}/${pack.Id}/preview-letter/${pack.Id}/${
        //     history.SignedUri ?? history.Uri
        //   }/${history.status !== 0 ? "signed" : "nonsigned"}`
        // );
      }}
      className={styles.box}
    >
      <div className={styles.boxWrapper}>
        <div className={styles.boxHeader}>
          <div className={styles.number}>{idx + 1}</div>
          <div className={styles.name}>
            {history?.Name ? history.Name : pack.S1}
          </div>
          <div className={styles.menu}>
            <div className={styles.hover}>
              <FontAwesomeIcon
                onClick={(e) => {
                  setShowMenu(!showMenu);
                  e.stopPropagation();
                }}
                icon={faEllipsisVertical}
                className={styles.menuIcon}
              />

              {showMenu && (
                <div className={styles.dropdown}>
                  <div
                    onClick={() => {
                      handleDownload();
                    }}
                    className={styles.dropdownItem}
                  >
                    <DownloadIcon title={t("common.downloadSourceFile")} />
                    {t("common.downloadSourceFile")}
                  </div>
                  <div
                    onClick={() => {
                      handlePreview();
                    }}
                    className={styles.dropdownItem}
                  >
                    <DownloadIcon title={t("common.previewSourceFile")} />
                    {t("common.previewSourceFile")}
                  </div>
                  <div
                    onClick={() => {
                      handleDuplicate();
                    }}
                    className={styles.dropdownItem}
                  >
                    <CopyIcon title={t("common.createCopy")} />
                    {t("common.createCopy")}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.signatures}>
          {history.Signatures &&
            history.Signatures.map((s: any, idx: number) => (
              <div className={styles.signature}>
                <SignatureIcon className={styles.icon}></SignatureIcon>
                <div className={styles.name}>{s.Label}</div>
                <div className={styles.date}>
                  {moment(s.Date).format("DD.MM.yyyy | HH:mm")}
                </div>
              </div>
            ))}
        </div>
        {/* {history.Status !== 0 && <div className={styles.signed}>Podpisany</div>} */}
      </div>
      {/* 
      <div className={styles.menu}>
        <TagIcon
          title="Edytuj pismo"
          onClick={() => {
            setShowModal(true);
          }}
        />
        <SignIcon
          title="Podpisz elektronicznie"
          onClick={() => {
            setCert({
              id: pack.Id,
              name: history.Name ?? pack.S1,
              versionId: history.Uri,
            });
            navigate(
              `/packages/${filterId}/${status}/${pack.Kind}/${
                pack.Id
              }/preview-letter/${pack.Id}/${history.SignedUri ?? history.Uri}/${
                history.status !== 0 ? 'signed' : 'nonsigned'
              }`
            );
          }}
        />
      </div> */}
      {showModal && (
        <CreateHistory
          pack={pack}
          history={history}
          toggle={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

const HistoryModal: FC<Props> = ({ pack, toggle }) => {
  const { data: histories } = editorService.useGetVersions(
    pack.Id,
    pack.Kind,
    true
  );

  return (
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div className={styles.title}>Wersje</div>
          <CloseIcon
            onClick={(e) => {
              toggle();
              // e.stopPropagation();
            }}
            className={styles.close}
          />
        </div>

        <div className={styles.list}>
          {histories
            ?.sort((a: any, b: any) => {
              const c = new Date(a.CreationDate);
              const d = new Date(b.CreationDate);
              //@ts-ignore
              return c - d;
            })
            .map((history: any, idx: number) => (
              <Box key={history.Id} pack={pack} history={history} idx={idx} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default HistoryModal;
